import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Box, Button, CardActions, Chip, Divider } from '@mui/material';
import { formatRevenue } from '../Pages/HomePage';
import PromoMatchDto from '../models/dtos/PromoMatchDto';
import PromoMatchModel from '../models/PromoMatchModel';
import { getLocalizedFromString, getLocalizedString, getLocalizedStringFor } from '../utils/LocalizationUtil';
import { useNavigate } from 'react-router-dom';
import PromoBannerDto from '../models/dtos/PromoBannerDto';
import ShopItemDto from '../models/dtos/ShopItemDto';
import { disableShopProduct, enableShopProduct } from '../Api';

interface ShopItemProps {
    item: ShopItemDto,
    previewLanguage: string,
    showEdit: boolean,
    onClick?: () => void,
    onStatusChanged?: () => void,
}

export default function ShopItemCard(model: ShopItemProps) {
    const navigate = useNavigate()
    let img = model.item.iconUrl;
    let title = getLocalizedFromString("", model.previewLanguage, model.item.titleText);
    let height = model.item.type == "Banner" ? '300px' : '150px';
    const isDisabled = model.item.isDeleted === true;
    const isNewCatalog = (model.item.storeCode ?? '').startsWith('new_shop_');
    const opacity = isDisabled ? 0.65 : 1;
    let effectDescription = getLocalizedFromString("", "en", model.item.effectName);
    if (effectDescription != undefined && effectDescription != null && effectDescription.length > 0){
        effectDescription = effectDescription.replace("%s", model.item.effectDuration?.toString() ?? "0");
    }

    const onToggleStatus = async (e: React.MouseEvent) => {
        e.stopPropagation();
        const result = isDisabled
            ? await enableShopProduct(model.item.id)
            : await disableShopProduct(model.item.id);
        if (!result) {
            window.alert('Server error!');
            return;
        }
        model.onStatusChanged?.();
    };

    return (
        <Card
            sx={{
                width: '100%',
                opacity,
                border: isDisabled ? '2px dashed #bdbdbd' : '2px solid transparent',
                bgcolor: isDisabled ? 'action.hover' : 'background.paper',
                position: 'relative',
            }}
        >
            {isDisabled ? (
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        zIndex: 1,
                        pointerEvents: 'none',
                        bgcolor: 'rgba(255,255,255,0.35)',
                    }}
                />
            ) : null}
            <div onClick={model.onClick} style={{ background: isDisabled ? '#757575' : '#285e8d', textAlign: 'center', verticalAlign:'center', color: 'white', cursor: 'pointer', minHeight:'40px', padding: '6px 8px' }}>
            <img style={{marginRight:'12px', marginTop:'4px', display:'inline-block', verticalAlign: 'middle', filter: isDisabled ? 'grayscale(1)' : 'none'}} src={model.item.osType == 'android' ? '/android_logo.png' : '/ios_logo.png'} width={20} height={20} />
                <b style={{ verticalAlign: 'middle' }}>[{model.item.type}] (interest factor: {model.item.interestFactor}%)</b>
                <Chip
                    size="small"
                    label={isDisabled ? 'DISABLED' : 'ACTIVE'}
                    color={isDisabled ? 'error' : 'success'}
                    variant={isDisabled ? 'filled' : 'outlined'}
                    sx={{ ml: 1, verticalAlign: 'middle', height: 22, fontWeight: 700 }}
                />
                <Chip
                    size="small"
                    label={isNewCatalog ? 'Shop v2 SKU' : 'Legacy SKU'}
                    color={isNewCatalog ? 'warning' : 'default'}
                    variant="outlined"
                    sx={{ ml: 0.5, verticalAlign: 'middle', height: 22 }}
                />
            </div>
            <Typography variant="h6" color="text.secondary" sx={{ color: 'black', textAlign: 'center', margin: '8px' }}>
                {model.item.storeCode}
            </Typography>
            <Divider />
            <CardContent sx={{ height: height, background: model.item.color, filter: isDisabled ? 'grayscale(0.85)' : 'none' }}>
                {model.item.type == "Banner" ?
                    <React.Fragment>
                        <br />
                        <img src={img} height={128} width={128} style={{ float: 'left', marginRight: '16px', marginTop: '-4px' }} />
                        {title == "" ? <React.Fragment/> : <React.Fragment><Typography variant="h4" color="inherit" noWrap display="inline">{title}</Typography><br/></React.Fragment>}
                        <Typography variant="h6" color="inherit" noWrap display="inline">{model.item.betcoins} Betcoins</Typography><br/>
                        <React.Fragment><Typography variant="h6" color="inherit" noWrap display="inline">{effectDescription}</Typography><br/></React.Fragment>
                        {model.item.noAds == true ? <React.Fragment><Typography variant="h6" color="inherit" noWrap display="inline">No Ads Forever!</Typography><br/></React.Fragment> : <div/>}
                        <br />
                        <Button size="medium" variant="contained" sx={{ width: '25%' }}>{model.item.visualPrice} $</Button>
                        <br /> <br />
                    </React.Fragment> : <React.Fragment>
                        <br />
                        <img src={img} height={64} width={64} style={{ float: 'left', marginRight: '16px', marginTop: '-4px' }} />
                        <Typography variant="h5" color="inherit" noWrap display="inline">{model.item.betcoins} Betcoins</Typography>&nbsp;&nbsp;&nbsp;
                        <Button size="medium" variant="contained" sx={{ width: '25%' }}>{model.item.visualPrice} $</Button>
                        <br/><br/><br/>
                        <Divider />
                    </React.Fragment>}
                <br />
            </CardContent>
            {model.showEdit ?
                <CardActions >
                    <Button size="small" color="primary" variant="contained" sx={{ marginLeft: 'auto', color: 'white' }} onClick={e => navigate('/shop-items/' + model.item.id + '/edit')}>
                        Edit
                    </Button>
                    <Button
                        size="small"
                        variant="outlined"
                        color={isDisabled ? 'success' : 'error'}
                        onClick={onToggleStatus}
                    >
                        {isDisabled ? 'Enable' : 'Disable'}
                    </Button>
                </CardActions> : <div />}
        </Card>
    );
}
